<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <div class="headline_under">
              <feather type="file-text" class="small-icon"></feather>
              <div class="v-super">Wohnungsangaben</div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="form-container">
                  <label>Name</label>
                  <b-input-group class="form-input-group" prepend="Abc">
                    <b-form-input class="form-control" v-model="name" prepend="Abc" v-bind:class="{ form_error: hasError('name') }"></b-form-input>
                  </b-input-group>
                  <label>Abkuerzung</label>
                  <b-input-group class="form-input-group" prepend="Abc">
                    <b-form-input
                      class="form-control"
                      type="text"
                      v-model="abkuerzung"
                      v-bind:class="{ form_error: hasError('abkuerzung') }"
                    ></b-form-input>
                  </b-input-group>
                  <label>Etage</label>
                  <b-input-group class="form-input-group" prepend="Abc">
                    <b-form-input class="form-control" type="text" v-model="etage" v-bind:class="{ form_error: hasError('etage') }"></b-form-input>
                  </b-input-group>
                  <label>Wohnfläche</label>
                  <b-input-group class="form-input-group" prepend="qm">
                    <b-form-input
                      class="form-control"
                      type="text"
                      v-model="wohnflaeche"
                      v-bind:class="{ form_error: hasError('wohnfläche') }"
                    ></b-form-input>
                  </b-input-group>
                  <label>Kaufpreis</label>
                  <b-input-group class="form-input-group" prepend="€">
                    <b-form-input
                      class="form-control"
                      type="text"
                      v-model="kaufpreis_json_computed"
                      name="kaufpreis_json_computed"
                      disabled
                    ></b-form-input>
                    <div class="input-buttons-inside">
                      <feather type="check" v-if="!updating.kaufpreis_json" class="checkmark"></feather>
                      <Loader size="20" v-if="updating.kaufpreis_json" />
                    </div>
                    <div class="input-buttons-right">
                      <feather type="plus" class="icon-button pointer" @click="addSubPreis()"></feather>
                      <feather type="chevron-down" class="icon-button pointer" @click="showKaufpreisDetails()"></feather>
                    </div>
                  </b-input-group>
                  <div id="show_preis" v-if="show.kaufpreis_json_show">
                    <div v-if="kaufpreis_json.length">
                      <div v-for="(prop, index) in kaufpreis_json" :key="'prop_' + index">
                        <div class="priceCon">
                          <div>{{ prop.bezeichnung }}</div>
                          <div class="infra-blue">{{ displayCurrency(prop.preis.toFixed(2).replace(".", ",")) }}</div>
                          <div><feather type="minus" class="icon-button pointer" @click="deletePreis(index)"></feather></div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      Keine Preise eingetragen.
                    </div>
                  </div>
                  <div id="add_preis" v-if="show.kaufpreis_json_add">
                    <div class="kaufpreis_inputs">
                      <b-input-group class="flex-col">
                        <label>Bezeichnung</label>
                        <b-form-input v-model="add.kaufpreis_bezeichung" name="new_kaupfreis_bezeichnung"></b-form-input>
                      </b-input-group>
                      <b-input-group class="flex-col">
                        <label>Wert</label>
                        <b-form-input v-model="add.kaufpreis_wert" name="new_kaufpreis_wert"></b-form-input>
                      </b-input-group>
                      <b-button size="md" @click="saveNewKaufpreis">Speichern</b-button>
                    </div>
                    <div id="kaufpreis_error_msg form-error" v-if="error.kaufpreis">
                      Bitte eine Bezeichnung und einen gültigen Zahlenwert eingeben.
                    </div>
                  </div>
                  <label>Zugeordnetes Haus</label>
                  <b-input-group class="form-input-group">
                    <b-form-select v-model="selected_haus" :options="hauser_options" @change="debug"></b-form-select>
                  </b-input-group>
                </div>
              </div>
              <div class="col col-lg-6">
                <div class="form-container">
                  <div class="form-label">Kurzbeschreibung</div>
                  <b-form-textarea rows="8" class="form-input-group" type="textarea" v-model="kurzbeschreibung"></b-form-textarea>
                  <div class="form-label">Besonderheiten</div>
                  <b-form-textarea rows="4" class="form-input-group" type="text" v-model="besonderheiten"></b-form-textarea>
                  <label>Status wählen</label>
                  <b-input-group class="form-input-group">
                    <b-form-select v-model="status" :options="status_options"></b-form-select>
                  </b-input-group>
                </div>
                <div class="btn btn-primary text-center " @click="validate">Wohnung erstellen</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="headline_under">
              <feather type="file-text" class="small-icon"></feather>
              <div class="v-super">Lageicon</div>
            </div>
            <vue-dropzone
              ref="lageicon_dropzone"
              :options="lageicon_dropzone_options"
              id="lageicon_dropzone"
              v-on:vdropzone-file-added="refreshDropzoneAuth"
              v-on:vdropzone-success="processAsset"
              v-if="lageicon_dropzone_options"
            ></vue-dropzone>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="headline_under">
              <feather type="file-text" class="small-icon"></feather>
              <div class="v-super">Grundriss</div>
            </div>
            <vue-dropzone
              ref="grundriss_dropzone"
              :options="grundriss_dropzone_options"
              id="grundriss_dropzone"
              v-on:vdropzone-file-added="refreshDropzoneAuth"
              v-on:vdropzone-success="processAsset"
              v-if="grundriss_dropzone_options"
            ></vue-dropzone>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vue2Dropzone from "vue2-dropzone";

export default {
  name: "AdminWohnungNew",
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      name: "",
      abkuerzung: "",
      etage: "",
      kurzbeschreibung: "",
      besonderheiten: "",
      lageicon_dropzone_options: false,
      grundriss_dropzone_options: false,
      wohnflaeche: "",
      kaufpreis: "",
      kaufpreis_json: "",
      status: "verfügbar",
      uploading: false,
      grundriss: false,
      lageicon: false,
      validation_errors: [],
      status_options: [
        { value: null, text: "Status wählen" },
        { value: "verfügbar", text: "verfügbar" },
        { value: "reserviert", text: "reserviert" },
        { value: "verkauft", text: "verkauft" },
      ],
      show: {
        kaufpreis_json_add: false,
        kaufpreis_json_show: false,
      },
      error: {
        kaufpreis: false,
      },
      hauser_options: [],
      haus: this.$route.params.haus_id,
      selected_haus: false,
      haus_bp: false,
      creating: false,
      updating: {
        name: false,
        abkuerzung: false,
        besonderheiten: false,
        etage: false,
        kaufpreis_json: false,
        wohnflaeche: false,
        kurzbeschreibung: false,
        status: false,
        selected_haus: false,
      },
      add: {
        kaufpreis_bezeichung: "",
        kaufpreis_wert: 0,
      },
      original: {},
    };
  },
  computed: {
    ...mapGetters({
      bauprojekte: "app/bauprojekte",
      api: "auth/apiSettings",
      toast: "app/toasts",
      hauser: "app/hauser",
      wohnungen: "app/wohnungen",
      token: "auth/apiToken"
    }),
    dzThumbSize() {
      return 250;
    },
    kaufpreis_json_computed() {
      if (this.kaufpreis_json == null || this.kaufpreis_json == "") return 0;
      let result = 0;
      this.kaufpreis_json.forEach((price) => {
        result = parseFloat(result) + parseFloat(price.preis);
      });

      return this.displayCurrency(
        parseFloat(result)
          .toFixed(2)
          .replace(".", ",")
      );
    },
  },
  created: async function() {
    //lageicon dropzone
    this.lageicon_dropzone_options = {
      url: this.api.customUploads,
      thumbnailMethod: "contain",
      thumbnailWidth: this.dzThumbSize,
      maxFiles: 1,
      init: function() {
        this.on("maxfilesexceeded", function(file) {
          this.removeAllFiles();
          this.addFile(file);
        });
      },
      dictDefaultMessage:
        '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload-cloud"><polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline></svg>',

      headers: {
        Authorization: "",
        "Cache-Control": null,
        "X-Requested-With": null,
      },
    };

    //grundriss dropzone
    this.grundriss_dropzone_options = {
      url: this.api.customUploads,
      thumbnailMethod: "contain",
      thumbnailWidth: this.dzThumbSize,
      maxFiles: 1,
      init: function() {
        this.on("maxfilesexceeded", function(file) {
          this.removeAllFiles();
          this.addFile(file);
        });
      },
      dictDefaultMessage:
        '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload-cloud"><polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline></svg>',

      headers: {
        Authorization: "",
        "Cache-Control": null,
        "X-Requested-With": null,
      },
    };

    //get bp of haus
    this.haus_bp = this.bauprojekte.find((bp) => {
      if (bp.id == this.$route.params.bauprojekt_id) return bp;
    });

    //assign hauser to select
    this.hauser_options = this.haus_bp.extended.hauser.map((h) => {
      if (h.id == this.haus) this.selected_haus = h.id;
      return {
        value: h.id,
        text: h.name,
      };
    });
  },
  methods: {
    async refreshDropzoneAuth() {      
      await this.$store.dispatch("auth/refreshToken");
      this.lageicon_dropzone_options.headers.Authorization = "bearer " + this.token;
      this.grundriss_dropzone_options.headers.Authorization = "bearer " + this.token;
    },  
    async deletePreis(idx) {
      this.kaufpreis_json.splice(idx, 1);
    },
    async saveNewKaufpreis() {
      this.error.kaufpreis = false;
      if (this.add.kaufpreis_bezeichung == "" || this.add.kaufpreis_wert == 0) {
        this.error.kaufpreis = true;
        return;
      } else {
        if (this.kaufpreis_json == null || this.kaufpreis_json == "") this.kaufpreis_json = [];
        const newKp = {
          bezeichnung: this.add.kaufpreis_bezeichung,
          preis: parseFloat(this.add.kaufpreis_wert.replace(",", ".")),
        };

        this.kaufpreis_json.push(newKp);
        this.updating.kaufpreis_json = false;
        this.show.kaufpreis_json_add = false;
        this.add.kaufpreis_wert = "";
        this.add.kaufpreis_bezeichung = "";
      }
    },
    showKaufpreisDetails() {
      console.log(this.kaufpreis_json);
      this.show.kaufpreis_json_show = this.show.kaufpreis_json_show ? false : true;
      this.show.kaufpreis_json_add = false;
    },
    addSubPreis() {
      this.show.kaufpreis_json_add = this.show.kaufpreis_json_add ? false : true;
      this.show.kaufpreis_json_show = false;
    },
    processUploadState() {
      return true;
    },
    processAsset(response = null, data = null) {
      //handle error / success of upload
      if (!response.xhr.status == 200) {
        this.$toasted.show("Fehler beim Upload", this.toast.error);
        return;
      }
      this.$toasted.show(data.data.filename_download + " Datum.", this.toast.success);

      //check what type of asset was uploaded
      const asset_type = response.previewElement.parentNode.id.split("_")[0];

      //tag the item in directus with the correct asset type
      this.$directus.files.updateOne(data.data.id, {
        tags: [asset_type, "draft"],
      });
      this[asset_type] = data.data.id;
      return true;
    },
    async validate() {
      this.validation_errors.splice(0, this.validation_errors.length);
      if (this.name.length < 5) this.validation_errors.push("name");
      if (!this.wohnflaeche.length) this.validation_errors.push("wohnfläche");

      if (!this.validation_errors.length) {
        const payload = {
          name: this.name,
          abkuerzung: this.abkuerzung,
          etage: this.etage,
          wohnflaeche: this.wohnflaeche,
          kaufpreis_json: this.kaufpreis_json,
          haus: this.haus,
          kurzbeschreibung: this.kurzbeschreibung,
          besonderheiten: this.besonderheiten,
          status: this.status,
          grundriss: this.grundriss ? this.grundriss : null,
          lageicon: this.lageicon ? this.lageicon : null,
        };
        try {
          this.creating = true;
          await this.$store.dispatch("app/addWohnung", payload);
          this.creating = false;
          this.$router.push("/admin/dashboard/bauprojekte/" + this.$route.params.bauprojekt_id);
        } catch (error) {
          this.$toasted.show(error, this.toast.error);
        }
      }
    },
    hasError(field) {
      return this.validation_errors.indexOf(field) > -1 ? true : false;
    },
    debug() {
      console.log(this.selected_haus);
    },
  },
};
</script>

<style>
.form-input-group {
  margin-bottom: 18px;
}

#grundriss_dropzone.dropzone .dz-default.dz-message,
#lageicon_dropzone.dropzone .dz-default.dz-message {
  left: 50% !important;
  top: 50% !important;
  width: auto !important;
  height: auto !important;
  transform: translate(-50%, -50%) !important;
  -webkit-transform: translate(-50%, -50%) !important;
  -moz-transform: translate(-50%, -50%);
  margin-left: 0px !important;
}

.form_error {
  border-color: red !important;
}
</style>

<style scoped>
.priceCon {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}

.priceCon div:first-of-type {
  width: 45%;
}

.form-group {
  position: relative;
}

#add_preis,
#show_preis {
  margin-bottom: 20px;
  border-bottom: 2px solid #004f7d;
}

#add_preis div {
  padding-right: 5px;
}

.flex-col {
  display: flex;
  flex-flow: column;
  margin-bottom: 10px;
}

.flex-col input {
  width: 100%;
}

.kaufpreis_inputs button {
  height: 38px;
  align-self: flex-end;
  margin-bottom: 10px;
}

.kaufpreis_inputs,
.kaufpreis_labels {
  display: flex;
  justify-content: flex-start;
}

.kaufpreis_labels {
  align-items: flex-start;
}

.input-buttons-inside {
  position: relative;
}

.input-buttons-right {
  display: flex;
  align-items: center;
}

.checkmark {
  color: green;
}

.failmark {
  color: red;
}

.loader {
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  -moz-backdrop-filter: none;
}
.loader,
.checkmark,
.failmark {
  position: absolute;
  bottom: 7px;
  right: 10px;
  display: block;
  height: 20px;
  width: 20px;
}

.checkmark.select,
.loader.select {
  right: 30px;
  z-index: 1000;
}
</style>

<style scoped>
.form-control{
  margin-right: 10px;
}

</style>